import styled, { css } from 'styled-components';

import { IconShare } from '@xing-com/icons';
import { xdlColorTextSecondary, spaceXS } from '@xing-com/tokens';
import { BodyCopy } from '@xing-com/typography';

import type { ShareCounterProps } from './share-counter';

// *** Base ***
const baseShareIcon = css`
  margin-right: ${spaceXS};
`;

const baseShareCounter = css`
  display: flex;
  color: ${xdlColorTextSecondary} !important;
`;

// *** Components ***
const ShareIcon = styled(IconShare)`
  ${baseShareIcon};
`;

const ShareCounter = styled(BodyCopy)<ShareCounterProps>`
  ${baseShareCounter};
`;

export const Styled = {
  ShareIcon,
  ShareCounter,
};
